
export const categoryData=[

    {
        id:"0",
        name:'Pubs'
    },

    
    {
        id:"1",
        name:'Restaurant'
    },

    
    {
        id:"2",
        name:'Mural spot'
    },

    
    {
        id:"3",
        name:'Chillout spot'
    },

    
    {
        id:"4",
        name:'Fitness spot'
    },

];